<template>
  <input-widget :model="model" :attribute="attribute" type="treepicker" :disabled="disabled"
                display-field="${item.name}" :placeholder="computedPlaceholder" :label="label"
                :multiple="multiple"
                :title-hint="titleHint" :hint="hint" :tree-picker-options="treePickerOptions" :items="itemLocations"
                @onTreepickerSelect="onSelect"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "ItemLocationSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      titleHint: {
        type: [Boolean, String],
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      placeholder: {
        type: [String, Boolean],
        default: null
      },
      flat: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapStateGlobal(['itemLocations']),
      computedPlaceholder() {
        return this.placeholder ? this.placeholder : this.$i18n.t('Select Location')
      },
      treePickerOptions() {
        return {
          normalizer: (node) => {
            return {
              id: node.uuid,
              label: node.name,
              children: node.children,
            }
          },
          flat: this.flat
        }
      }
    },
    methods: {
      onSelect(val) {
        this.$emit('select', val)
      }
    }
  }
</script>

<style scoped>

</style>
